import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { type Organization } from './graphql/useGetAllOrganizations';

type HeadViewProps = {
  data: Organization[];
  onEditClick: (id: string, isDepartment?: boolean, facultyId?: string) => void;
};

export const HeadView: React.FC<HeadViewProps> = ({ data, onEditClick }) => {
  const [viewType, setViewType] = useState<'FACULTY' | 'DEPARTMENT'>('FACULTY');

  const handleViewChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setViewType(event.target.value as 'FACULTY' | 'DEPARTMENT');
  };

  return (
    <Box p={2}>
      <RadioGroup
        row
        value={viewType}
        onChange={handleViewChange}
        sx={{ mb: 3 }}
      >
        <FormControlLabel
          value="FACULTY"
          control={<Radio />}
          label="Faculty/School"
        />
        <FormControlLabel
          value="DEPARTMENT"
          control={<Radio />}
          label="Department/School"
        />
      </RadioGroup>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '25%' }}>
              {viewType === 'FACULTY' ? 'Faculty/School' : 'Department/School'}
            </TableCell>
            <TableCell sx={{ width: '25%' }}>
              {viewType === 'FACULTY' ? 'Dean' : 'Head'}
            </TableCell>
            <TableCell sx={{ width: '25%' }}>Email</TableCell>
            <TableCell sx={{ width: '25%' }}>Edit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Faculty/School View */}
          {viewType === 'FACULTY' &&
            data?.map((organization: Organization) =>
              organization.dean ? (
                <TableRow key={organization._id}>
                  <TableCell>{organization.abbreviation}</TableCell>
                  <TableCell>
                    {`${organization.dean.givenName} ${organization.dean.surname} (${organization.dean.netId})`}
                  </TableCell>
                  <TableCell>{organization.dean.email}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        onEditClick(organization._id);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ) : null,
            )}

          {/* Department View */}
          {viewType === 'DEPARTMENT' &&
            data?.map((organization: Organization) =>
              organization.departments?.map(department =>
                department.head ? (
                  <TableRow key={department.id}>
                    <TableCell>{department.abbreviation}</TableCell>
                    <TableCell>
                      {`${department.head.givenName} ${department.head.surname} (${department.head.netId})`}
                    </TableCell>
                    <TableCell>{department.head.email}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          onEditClick(department.id, true, organization._id);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ) : null,
              ),
            )}
        </TableBody>
      </Table>
      <Divider sx={{ marginY: 2 }} />
    </Box>
  );
};
